// extracted by mini-css-extract-plugin
export default {"activityModalWrapper":"ActivityAnnotation_activityModalWrapper__bSbU8","activityModal":"ActivityAnnotation_activityModal__wR6fB"};